module.exports = __webpack_public_path__ + "img/branches-logo-active.7117624c.svg";